var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { AnalyticsEvent } from "@lonelyplanet/dotcom-analytics";
import { Urls } from "@lonelyplanet/dotcom-routing/dist/create";
import Button from "backpack-ui/dist/components/button";
import MoreLink from "backpack-ui/dist/components/moreLink";
import * as React from "react";
import * as styles from "./styles.css";
var Activities = function (_a) {
    var data = _a.data, _b = _a.buttonColor, buttonColor = _b === void 0 ? "blue" : _b, parentActivityName = _a.parentActivityName, _c = _a.url, url = _c === void 0 ? "#" : _c, placeId = _a.placeId, containingPlaces = _a.containingPlaces;
    return (React.createElement(AnalyticsEvent, { render: function (track) { return (React.createElement(React.Fragment, null,
            data.map(function (activity, index) { return (React.createElement(React.Fragment, { key: activity.name },
                React.createElement("div", { className: styles.activity },
                    React.createElement("div", { className: styles.activityName }, activity.name),
                    React.createElement("div", { className: styles.activityPrice },
                        activity.pricing.regularPrice.formattedAmount,
                        React.createElement("br", null),
                        React.createElement("span", { className: styles.activityPriceLabel }, "and up")),
                    React.createElement("div", { className: styles.activityButton },
                        React.createElement(Button, { href: Urls.create(__assign({}, activity, { containingPlaceId: placeId, containingPlaces: containingPlaces })), size: "tiny", color: buttonColor, border: true, rounded: true, target: "_blank", onClick: function (e) {
                                track({
                                    bookingName: activity.name,
                                    bookingProvider: "viator",
                                    event: "partner click",
                                    "gtm.element": "activities-button-" + index,
                                });
                            } }, "Details"))))); }),
            url && (React.createElement("div", { className: styles.moreLink },
                React.createElement(MoreLink, { href: url, size: "small", caps: true, rel: "noopener noreferrer", target: "_blank", onClick: function () {
                        track({
                            bookingProvider: "viator",
                            event: "partner click",
                            "gtm.element": "moretickets",
                            "gtm.elementText": "More tickets &amp; tours",
                        });
                    } }, "More tickets & tours"))))); } }));
};
export default Activities;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/activities/index.tsx
// module id = PqV5
// module chunks = 2